import gql from 'graphql-tag';

export const OVERVIEW = gql`
  query accommodationsActivitiesOverview($businessOwnerId: Int) {
    accommodationsBookingsOverview(businessOwnerId: $businessOwnerId) {
      currentBookingsNumber
      newBookingsNumber
      arrivalGuestsNumber
      departureGuestsNumber
      canceledBookingsNumber
      bookingsWhichStartToday
      bookingsWhichEndToday
    }
    activitiesBookingsOverview(businessOwnerId: $businessOwnerId) {
      currentBookingsNumber
      newBookingsNumber
      arrivalGuestsNumber
      canceledBookingsNumber
      bookingsWhichStartToday
    }
  }
`;

export const UPCOMING_ACCOMMODATIONS = gql`
  query accommodationsBookings(
    $orderBy: String
    $businessOwnerId: Int
    $closestEventsPeriod: String
  ) {
    accommodationsBookings(
      isClosestEvents: true
      orderBy: $orderBy
      businessOwnerId: $businessOwnerId
      closestEventsPeriod: $closestEventsPeriod
    ) {
      id
      toDate
      fromDate
      referenceNumber
      creationTime
      isRelated
      guestFirstName
      guestLastName
      bookingNotes
      deactivationBooking
      platform
      closestEvent {
        id
        date
        event
      }
      guests {
        totalPrice
        guestsNumber
        participant {
          participant
        }
      }
      bookedAddOns {
        addOn {
          title
        }
        addOnCount
        totalPrice
      }
      accommodation {
        id
        title
        checkInTime
        checkOutTime
      }
      payments {
        id
        currency {
          currency
        }
        totalPrice
      }
      relatedActivitiesBookings {
        id
        activity {
          title
        }
        guests {
          totalPrice
          guestsNumber
          participant {
            participant
          }
        }
        payments {
          currency {
            currency
          }
          totalPrice
        }
        bookedAddOns {
          addOn {
            title
          }
          addOnCount
          totalPrice
        }
      }
    }
  }
`;

export const UPCOMING_ACTIVITIES = gql`
  query activities($businessOwnerId: Int, $closestEventsPeriod: String) {
    activities(
      isClosestEvents: true
      businessOwnerId: $businessOwnerId
      closestEventsPeriod: $closestEventsPeriod
    ) {
      id
      title
      productCode
      isOpen
      isPrivate
      minParticipants
      maxParticipants
      closestEvent {
        duration
        startDate
        startTime
        timeType
      }
      activityBookings {
        id
        platform
        guestFirstName
        guestLastName
        deactivationBooking
        guests {
          guestsNumber
          totalPrice
          participant {
            participant
          }
        }
        payments {
          currency {
            currency
          }
          totalPrice
        }
      }
    }
  }
`;
